import styled from "styled-components";
import Box from "../box/Box";
import { getValueFromPixelString } from "../../utils/TokenHelpers";
import { apolloSpaceInset1X, apolloSpaceInset2X } from "@nexthink/apollo-tokens";
export const StyledTableGroupingLoadMoreRow = styled.tr.withConfig({ displayName: "StyledTableGroupingLoadMoreRow_APC-7281-productShell", componentId: "sc-124n43s" })({
    "&& td": {
        paddingBottom: "1px",
    },
});
export const StyledDashContainer = styled(Box).withConfig({ displayName: "StyledDashContainer_APC-7281-productShell", componentId: "sc-735skl" })({
    display: "inline-flex",
    paddingLeft: `${getValueFromPixelString(apolloSpaceInset2X) - 1}px`,
    paddingRight: `${getValueFromPixelString(apolloSpaceInset1X) - 1}px`,
});
export const StyledDashSvg = styled.svg.withConfig({ displayName: "StyledDashSvg_APC-7281-productShell", componentId: "sc-4zxbs9" })({
    width: "2px",
    height: "14px",
});
export const StyledDashLine = styled.line.withConfig({ displayName: "StyledDashLine_APC-7281-productShell", componentId: "sc-13nc5l7" })(({ theme }) => ({
    strokeWidth: "2px",
    stroke: theme.colors.apolloColorStrokeSeparator,
    strokeDasharray: "2 4",
}));
//# sourceMappingURL=TableGroupingPaginationRow.style.js.map